<template>
    <div style="margin-left: 110px; margin-right: 110px;">
        <div style="margin-left: 15px; margin-top: 20px; margin-bottom: 10px;">
            <table style="width: 100%; border: none;">
                <tr>
                    <td style="text-align: left; width: 10.5%; border: none;">其它平台购买者Email</td>
                    <td style="text-align: left; width: 89.5%; border: none;"><input id="input_email" style="width: 240px;" type="text" v-model="email" @change="getAddress()"/></td>
                </tr>
            </table>
        </div>
        <b-tabs card @input="handleTabChange">
            <b-tab title="收货地址" :active="activeTabIndex === 0">
                <div>
                    <table style="width: 100%; border: none;">
                        <tr>
                            <td style="text-align: left; width: 3%; border: none;">姓名</td>
                            <td style="text-align: left; width: 97%; border: none;"><input id="input_name" style="width: 240px;" type="text" v-model="name"/></td>
                        </tr>
                        <tr>
                            <td style="text-align: left; width: 3%; border: none;">地址</td>
                            <td style="text-align: left; width: 97%; border: none;"><input id="input_address" style="width: 240px;" type="text" v-model="address"/></td>
                        </tr>
                        <tr>
                            <td style="text-align: left; width: 3%; border: none;">电话</td>
                            <td style="text-align: left; width: 97%; border: none;"><input id="input_phone" style="width: 240px;" type="text" v-model="phone"/></td>
                        </tr>
                    </table>
                </div>
                <div style="margin-top: 20px;">
                    <button type="button" class="btn btn-primary" @click="setAddress()">保存</button>
                </div>
                <div v-if="message1" style="margin-top: 10px;">
                    <p style="color: red;">{{ message1 }}</p>
                </div>
            </b-tab>
            <b-tab title="所购商品" :active="activeTabIndex === 1">
                <div>
                    <table style="width: 100%; border: none;">
                        <tr>
                            <td style="width: 30%;">
                                <div style="width: 35%; float: left;">其它平台交易号</div>
                                <div style="width: 65%; float: left;"><input id="input_trade_no" style="width: 240px;" type="text" v-model="trade_no"/></div>
                            </td>
                            <td style="width: 70%;">
                                <div style="width: 8%; float: left;">商品标题</div>
                                <div style="width: 92%; float: left;"><input id="input_subject" style="width: 240px;" type="text" v-model="subject"/></div>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 30%;">
                                <div style="width: 35%; float: left;">其它平台买家用户编码</div>
                                <div style="width: 65%; float: left;"><input id="input_buyer_open_id" style="width: 240px;" type="text" v-model="buyer_open_id"/></div>
                            </td>
                            <td style="width: 70%;">
                                <div style="width: 8%; float: left;">IP 地址</div>
                                <div style="width: 92%; float: left;"><input id="input_ip" style="width: 240px;" type="text" v-model="ip"/></div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div style="margin-top: 20px;">
                    <button type="button" class="btn btn-primary" style="margin-right: 10px;" @click="getGw()">获取该用户企业网关信息</button>
                    <button type="button" class="btn btn-primary" @click="setOrders()">保存</button>
                </div>
                <div v-if="message2" style="margin-top: 10px;">
                    <p style="color: red;">{{ message2 }}</p>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    name: 'Manual',
    data() {
        return {
            activeTabIndex: 0, // 初始激活的tab索引
            email: '',
            name: '',
            address: '',
            phone: '',
            trade_no: '',
            subject: '',
            buyer_open_id: '',
            ip: '',
            message1: '',
            message2: ''
        };
    },
    methods: {
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },

        handleTabChange(newTabIndex) {
            this.activeTabIndex = newTabIndex; // 更新当前激活的tab索引
            // this.msg1 = '';
            // this.msg2 = '';
            // this.msg3 = '';
        },

        getAddress() {
            this.message1 = '';

            if (!this.email) {
                this.message1= "其它平台购买者Email不能为空";
                return;
            }

            var config = {
                method: 'post',
                url: 'getaddr',
                data: {
                    email: this.email
                }
            };

            this.$axios(config)
                .then(response => {
                    if(response.status == 200) {
                        this.message1 = response.data.message;
                        const jsonString = response.data.data;
                        let allData = JSON.parse(jsonString);

                        this.name = allData.name;
                        this.address = allData.address;
                        this.phone = allData.phone;
                    }     
                    if(response.status == 222) {
                        this.message1 = response.data.message;
                        if(response.data.code === 2001) {
                            this.name = '';
                            this.address = '';
                            this.phone = '';
                        }
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.message1 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
                    } else if (error.request) {
                        this.message1 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
                    } else {
                        this.message1 = '发生未知错误';
                    }
                });
        },

        setAddress() {
            this.message1 = '';

            if (!this.email) {
                this.message1= "其它平台购买者Email不能为空";
                return;
            }

            if (!this.name) {
                this.message1= "姓名不能为空";
                return;
            }

            if (!this.address) {
                this.message1= "地址不能为空";
                return;
            }

            if (!this.phone) {
                this.message1= "电话不能为空";
                return;
            }

            var config = {
                method: 'post',
                url: 'setaddr',
                data: {
                    email: this.email,
                    name: this.name,
                    address: this.address,
                    phone: this.phone
                }
            };

            this.$axios(config)
                .then(response => {
                    if(response.status == 200) {
                        this.message1 = response.data.message;
                    }     
                    if(response.status == 222) {
                        this.message1 = response.data.message;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.message1 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
                    } else if (error.request) {
                        this.message1 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
                    } else {
                        this.message1 = '发生未知错误';
                    }
                });
        },

        getGw() {
            this.message1 = '';
            this.message2 = '';

            if (!this.email) {
                this.message2 = "其它平台购买者Email不能为空";
                return;
            }

            var config = {
                method: 'post',
                url: 'getgw',
                data: {
                    email: this.email
                }
            };

            this.$axios(config)
                .then(response => {
                    if(response.status == 200) {
                        this.message2 = response.data.message;
                    }     
                    if(response.status == 222) {
                        this.message2 = response.data.message;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.message2 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
                    } else if (error.request) {
                        this.message2 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
                    } else {
                        this.message2 = '发生未知错误';
                    }
                });
        },

        setOrders() {
            this.message1 = '';
            this.message2 = '';

            if (!this.email) {
                this.message2 = "其它平台购买者Email不能为空";
                return;
            }

            if (!this.trade_no) {
                this.message2 = "其它平台交易号不能为空";
                return;
            }

            if (!this.subject) {
                this.message2 = "商品标题不能为空";
                return;
            }

            if (!this.validEmail(this.email)) {
                this.message2 = "其它平台购买者Email不是有效的地址";
                return;
            }

            let platform = this.trade_no.slice(0, 2); // JD: 京东 TB: 淘宝 TM: 天猫 XY: 闲鱼
            if ((platform !== 'JD') && (platform !== 'TB') && (platform !== 'TM') && (platform !== 'XY')) {
                this.message2 = "其它平台交易号首部两个字符必须是JD(京东), TB(淘宝), TM(天猫)或XY(闲鱼)";
                return;
            }

            const product_regex = /^\d+lowgw_\d+midgw_\d+highgw_\d+lowmgw_\d+midmgw_\d+highmgw_\d+lowmterm_\d+midmterm_\d+highmterm$/;
            const custom_regex = /^\d+custom$/;
            if (!(product_regex.test(this.subject) ||
                this.subject === '1plan' ||
                this.subject === '2plan' ||
                this.subject === '3plan' ||
                custom_regex.test(this.subject))) {
                this.message2 = "无效的商品标题";
                return;
            }

            if (this.buyer_open_id) {
                let pf = this.buyer_open_id.slice(0, 2); // JD: 京东 TB: 淘宝 TM: 天猫 XY: 闲鱼
                if ((pf !== 'JD') && (pf !== 'TB') && (pf !== 'TM') && (pf !== 'XY')) {
                    this.message2 = "其它平台买家用户编码首部两个字符必须是JD(京东), TB(淘宝), TM(天猫)或XY(闲鱼)";
                    return;
                }
            }

            if (custom_regex.test(this.subject)) {
                if (!this.ip) {
                    this.message2 = "定制产品的 IP 地址不能为空";
                    return;
                }
            }

            var config = {
                method: 'post',
                url: 'setorders',
                data: {
                    email: this.email,
                    trade_no: this.trade_no,
                    subject: this.subject,
                    buyer_open_id: this.buyer_open_id ? this.buyer_open_id : '' ,
                    ip: this.ip ? this.ip : ''
                }
            };

            this.$axios(config)
                .then(response => {
                    if(response.status == 200) {
                        this.message2 = response.data.message;
                    }     
                    if(response.status == 222) {
                        this.message2 = response.data.message;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.message2 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
                    } else if (error.request) {
                        this.message2 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
                    } else {
                        this.message2 = '发生未知错误';
                    }
                });
        }

    }
}
</script>
    
<style scoped>
</style>
